
import React from "react";
import { toast } from "sonner";

interface WritingEditorProps {
  content: string;
  onChange: (value: string) => void;
  isLocked?: boolean;
  topicId?: string;
}

export const WritingEditor = ({ content, onChange, isLocked, topicId }: WritingEditorProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newContent = e.target.value;
    onChange(newContent);
  };

  const handleFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    if (!topicId) {
      toast.info("You can keep writing - we all need to put our thoughts down sometimes, but if you'd like to evaluate your essay - please select a topic first 🙂", {
        duration: 6000,
      });
    }
  };

  return (
    <div className="relative bg-white dark:bg-stone-900 border-b border-stone-200 dark:border-stone-700">
      <textarea
        value={content}
        onChange={handleChange}
        onFocus={handleFocus}
        disabled={isLocked}
        placeholder="Start writing your response here..."
        className="w-full h-[500px] px-8 py-6 resize-none focus:outline-none disabled:bg-gray-50 dark:bg-stone-800 dark:text-white dark:placeholder:text-stone-400"
      />
    </div>
  );
};
